import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import pointsMall from './modules/pointsMall';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        name: '',
        isSelect: {
            tab: 'Study',
            index: 0
        },
        userCode: '123',
        platformType: 'ECS',
        userInfo: {} // 积分商城用户信息
    },
    mutations: {
        //
        changeSelect: (state, select) => {
            state.isSelect.tab = select.tab;
            state.isSelect.index = select.index;
        },
        setUserCode: (state, users) => { // 存储用户编号
            state.userCode = users;
        },
        setPlatformType: (state, platformType) => { // 存储平台类型
            state.platformType = platformType;
        }
    },
    actions: {

    },
    modules: {
        user,
        pointsMall
    }
});

export default store;


// WEBPACK FOOTER //
// src/store/index.js